const courses = [
    {
        title: 'CS 415 Software Product Line Engineering',
        prerequisite: 'CS 319',
        description: 'Software reuse, SPLE methods, domain engineering, application engineering, commonality and variability analysis, variability modeling, reference architecture, application architecture, software product portfolio management, software product line scoping, testing in SPLE, organization structures for SPLE, risks of SPLE, adoption strategies for SPLE.',
        catalog: 'https://catalog.bilkent.edu.tr/current/course/c11415.html',
        url: ''
    },
    {
        title: 'CS 453 Application Lifecycle Management',
        prerequisite: 'CS 319',
        description: 'Application lifecycle management process, software development in large-scale IT organizations, software development productivity, agile software development, project management, requirements management, architecture and design, software development, software test management, software configuration management, change management, and build management.',
        catalog: 'https://catalog.bilkent.edu.tr/current/course/c11453.html',
        url: ''
    },
    {
        title: 'CS 319 Object-Oriented Software Engineering',
        prerequisite: 'CS 201',
        description: 'Principles and stages of object-oriented software development. Overview of object-oriented software modeling with Unified Modeling Language and exposure to CASE tools for object-oriented development. Experience with such tools and environments through programming assignments and/or a term project.',
        catalog: 'https://catalog.bilkent.edu.tr/current/course/c11319.html',
        url: 'http://www.cs.bilkent.edu.tr/~eraytuzun/teaching/cs319/'
    },
    {
        title: 'CS 588 Data Science for Software Engineering',
        prerequisite: '',
        description: 'Data science for software engineering basics. Role of data science in various phases of the software development lifecycle. Research fundamentals (how to read/write/review a research paper). Research methods for software engineering. Mining data from online software repositories. Developer and team productivity. Expert recommendation. Survey and project proposal presentations. Application of graph-based metrics and algorithms. Ground truth data in software engineering. Process smells, AI-assisted code generation',
        catalog: 'https://catalog.bilkent.edu.tr/current/course/c11588.html',
        url: ''
    },
];

export default courses;
